<template>
  <li
    v-show="show"
    :class="stateClasses"
  >
    <div class="state-messages-content">
      <template v-if="loading">
        <spinner-animated
          class="state-messages-spinner"
          color="gray"
          size="small"
        />

        <slot name="loading">
          Carregando
        </slot>
      </template>

      <template v-else-if="error">
        <h2
          v-if="oops"
          class="app-h2 state-messages-header"
        >
          Oops...
        </h2>

        <slot name="error">
          Algo deu errado!
        </slot>
      </template>

      <template v-else-if="empty">
        <img
          v-if="iconed"
          :src="illustration"
          alt="empty"
          class="state-message-empty-icon"
        >

        <slot name="empty">
          Nenhum resultado
        </slot>
      </template>
    </div>
  </li>
</template>

<script>
  import illustration from '@/assets/images/illustrations/list/empty-list.jpg';

  import SpinnerAnimated from '@/components/Spinner/Animated.vue';

  export default {
    name: 'StateMessages',
    components: {
      SpinnerAnimated,
    },
    props: {
      state: {
        type: String,
        default: 'ready',
      },
      oops: {
        type: Boolean,
        default: true,
      },
      iconed: {
        type: Boolean,
        default: true,
      },
    },
    data() {
      return {
        illustration,
      };
    },
    computed: {
      show() {
        return ['error', 'loading', 'empty'].indexOf(this.state) > -1;
      },
      loading() {
        return this.state === 'loading';
      },
      error() {
        return this.state === 'error';
      },
      empty() {
        return this.state === 'empty';
      },

      stateClasses() {
        const classes = ['state-messages'];

        classes.push(`state-messages-${this.state}`);

        return classes;
      },

    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/stylesheets/_variables.scss';

  .state-messages {
    align-items: center;
    color: $gray;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: $gutter-big $gutter;
    text-align: center;

    &:hover {
      background-color: $white !important;
    }
  }

  .state-messages-content {
    flex: 1;
  }

  .state-messages-error {
    color: $red;
  }

  .state-messages-spinner {
    margin-right: 0.25em;
  }

  .state-messages-icon {
    margin-right: 0.25em;
  }

  .state-messages-header {
    display: block;
  }

  .state-message-empty-icon {
    display: block;
    margin: 0 auto $gutter-small;
    max-width: 120px;
  }
</style>
